<span>
  <label *ngIf="props.altLabel" [for]="field.id">{{ props.altLabel }}</label>
  <textarea
    class="{{ !!formControl.value ? 'p-filled' : '' }}"
    pInputTextarea
    [autoResize]="props.autoResize"
    [placeholder]="props.placeholder"
    [maxlength]="props.maxlength"
    [readonly]="props.readonly"
    [required]="props.required"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [id]="field.id"
    [name]="field.id"
    (keydown)="props.keydown ?? onKeyDown($event)"
  ></textarea>
</span>
